<div class="delete-account-dialog">
  <h2 class="title-9 d-flex justify-content-center uppercase">
    <span mat-dialog-title>Confirm Account Deletion</span>
  </h2>

  <mat-dialog-content class="confirmation-msg center title-10 text-w-500 mt-2" role="alert">
    <p>
      I understand that deleting my account is irreversible, and I will lose access to all my data
      on
      {{ appName }} Application.
    </p>
    <p>Take care of your health, and if you ever need our support, we're just a message away.</p>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="action-buttons">
    <button mat-raised-button (click)="confirm()" cdkFocusInitial class="primary-button">
      Confirm
    </button>

    <button (click)="close()" mat-raised-button class="secondary-button cancel-button uppercase">
      Cancel
    </button>
  </mat-dialog-actions>
</div>
